import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]

import { 
		clsx
	} from 'clsx'

	
	const __default__ = { name: 'VPagination' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		ariaLabel: {
			type: String,
			default: 'Page navigation'
		},
		className: {
			type: String,
			default: ''
		}
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    "aria-label": __props.ariaLabel,
    class: _normalizeClass(_unref(clsx)(__props.className, 'flex gap-x-2'))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})